import { useEffect, useRef } from 'react';

import { ANALYTICS_SOURCE, BYLINE_ACTION_SUBJECT_ID } from '../analytics.ts';
import { useTwgAnalyticsEvents } from '../useTwgAnalyticsEvents.ts';

type BylineConnectionsViewedEventOptions = {
	hiddenBySsr: boolean;
	isResolving: boolean;
	shouldRenderByline: boolean;
};

export const useBylineConnectionsViewedEvent = ({
	hiddenBySsr,
	isResolving,
	shouldRenderByline,
}: BylineConnectionsViewedEventOptions): void => {
	const { createAnalyticsEvent } = useTwgAnalyticsEvents();
	const hasFiredViewedRef = useRef(false);
	// Fire a single "viewed" event the first time the byline actually renders its
	// content — skip while resolving and while there is nothing to show (both cases
	// early-return before the trigger is visible).
	useEffect(() => {
		if (hiddenBySsr || hasFiredViewedRef.current || isResolving || !shouldRenderByline) {
			return;
		}
		hasFiredViewedRef.current = true;
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'viewed',
				actionSubject: 'byline',
				actionSubjectId: BYLINE_ACTION_SUBJECT_ID,
				source: ANALYTICS_SOURCE,
			},
		}).fire();
	}, [createAnalyticsEvent, hiddenBySsr, isResolving, shouldRenderByline]);
};
